import {
  isToday,
  isThisYear,
  endOfDay,
  startOfDay,
  isWithinInterval,
  differenceInHours
} from 'date-fns';
import dateFormat from 'dateformat';
import eventFormatter from '#component/device/event-formatter';
import { getDateTimeFormat } from '#helper';

const hoursDiff = intervalStart => differenceInHours(new Date(), intervalStart);

const isEventWithinInterval = (eventDate, rangeStart, rangeEnd) =>
  isWithinInterval(eventDate, { start: rangeStart, end: rangeEnd });

const formatGroupDate = (item, account) =>
  dateFormat(
    item.timestamp,
    getDateTimeFormat(account && account.measurementSystem, isThisYear(new Date(item.timestamp)) ? 'dateTime' : 'dateShort')
  );

export const getEventDate = (item, account) =>
  eventFormatter(item, account, isThisYear(new Date(item.timestamp)) ? '' : 'dateTimeShort');

export const getGroupDate = (start, account) => {
  const hoursAgo = hoursDiff(new Date(start.timestamp));

  if (hoursAgo >= 1 && hoursAgo < 3) {
    return '1 hour ago';
  }
  if (hoursAgo >= 3 && hoursAgo < 6) {
    return '3 hours ago';
  }
  if (hoursAgo >= 6 && hoursAgo < 12) {
    return '6 hours ago';
  }
  if (hoursAgo >= 12 && hoursAgo < 24) {
    return '12 hours ago';
  }

  return formatGroupDate(start, account);
};

export const groupEvents = events => {
  const h = 1000 * 60 * 60;
  const result = {};
  const lessThanHour = [];

  const setDayRange = (event, today, eventDate, range) => {
    const dateIntervalEnd = today;
    const dateIntervalStart = new Date(+today - range * h);

    const rangeStart = startOfDay(new Date());
    const rangeEnd = endOfDay(new Date());

    if (isEventWithinInterval(eventDate, rangeStart, rangeEnd)) {
      const startDate = dateFormat(dateIntervalStart, 'isoUtcDateTime').split('T')[0];
      const endDate = dateFormat(dateIntervalEnd, 'isoUtcDateTime').split('T')[0];
      const dateRangeKey = `${startDate}__${endDate}`;

      result[dateRangeKey] = result[dateRangeKey] || [];
      result[dateRangeKey].push(event);
    }
  };

  const today = new Date();

  events.forEach(event => {
    const { timestamp } = event;
    const eventDate = new Date(timestamp);

    if (isToday(eventDate)) {
      const hoursAgo = hoursDiff(eventDate);
      switch (true) {
        case hoursAgo < 1:
          lessThanHour.push(event);
          return;
        case hoursAgo >= 1 && hoursAgo < 3:
          setDayRange(event, today, eventDate, 3);
          return;
        case hoursAgo >= 3 && hoursAgo < 6:
          setDayRange(event, today, eventDate, 6);
          return;
        case hoursAgo >= 6 && hoursAgo < 12:
          setDayRange(event, today, eventDate, 12);
          return;
        case hoursAgo >= 12 && hoursAgo < 24:
          setDayRange(event, today, eventDate, 23);
          return;
        default:
          break;
      }
    }

    const rangeEnd = endOfDay(eventDate);
    const rangeStart = startOfDay(eventDate);

    if (isEventWithinInterval(eventDate, rangeStart, rangeEnd)) {
      const startDate = dateFormat(rangeStart, 'isoUtcDateTime').split('T')[0];
      const endDate = dateFormat(rangeEnd, 'isoUtcDateTime').split('T')[0];
      const dateRangeKey = `${startDate}__${endDate}`;

      result[dateRangeKey] = result[dateRangeKey] || [];
      result[dateRangeKey].push(event);
    }
  });

  const sortedGroupKeys = Object.keys(result).sort((a, b) => b.localeCompare(a));
  const sortedGroupData = sortedGroupKeys.map(groupKey => result[groupKey]);

  return [
    ...lessThanHour,
    ...sortedGroupData
  ];
};
